export const version = "2.0-beta (0.10.4-216-gfe315a81)";
